export function playbackFraction(currentTime: number, duration: number) {
  if (!Number.isFinite(currentTime) || !Number.isFinite(duration) || duration <= 0) {
    return 0;
  }
  return Math.max(0, Math.min(currentTime / duration, 1));
}

export function isPlaybackTimeDiscontinuity(
  previousTime: number,
  currentTime: number,
  sampleIntervalMs: number,
  playbackRate = 1
) {
  const normalizedRate = Number.isFinite(playbackRate) && playbackRate > 0
    ? playbackRate
    : 1;
  const ordinaryAdvance = Math.max(0.25, (sampleIntervalMs / 1000) * normalizedRate);
  return (
    currentTime < previousTime - 0.2 ||
    currentTime > previousTime + Math.max(2, ordinaryAdvance * 2.5)
  );
}
